import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  formHeaderLabel: {
    description: 'Label for the form when creating a new V1 API Key',
    id: '4dBtMZ',
    defaultMessage: 'Set key expiration',
  },
  label12Months: {
    defaultMessage: '12 months',
    id: 'MONd9L',
    description: 'Label for the Radio input',
  },
  label6Months: {
    defaultMessage: '6 months',
    id: 'LS/3u7',
    description: 'Label for the Radio input',
  },
  label3Months: {
    defaultMessage: '3 months',
    id: '2PHURU',
    description: 'Label for the Radio input',
  },
});
